import { render, staticRenderFns } from "./texTem.vue?vue&type=template&id=4ec74b24&scoped=true&"
import script from "./texTem.vue?vue&type=script&lang=js&"
export * from "./texTem.vue?vue&type=script&lang=js&"
import style0 from "./texTem.vue?vue&type=style&index=0&id=4ec74b24&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec74b24",
  null
  
)

export default component.exports